export const promocodeTypes = {
    GET_PROMOCODES: "GET_PROMOCODES",
    NEW_PROMOCODE: "NEW_PROMOCODE",
    SET_PROMOCODE_FILTERS: "SET_PROMOCODE_FILTERS",
    SET_BRANDS: "SET_BRANDS",
    SET_SELECTED_PROMOCODE: "SET_SELECTED_PROMOCODE",
    DELETE_PROMOCODE: "DELETE_PROMOCODE",
    UPDATE_PROMOCODE: "UPDATE_PROMOCODE"
}